export default "__VITE_ASSET__6cd405ad__"